// ========================
// HelpBlogs 顶部搜索自动建议
// ========================

let helpSearchTimer = null;
const HELP_MIN_LENGTH = 2;
const HELP_DEBOUNCE = 300;

function renderHelpSearchResults(results, container) {
    container.innerHTML = '';
    if (!results || results.length === 0) {
        container.classList.remove('show');
        return;
    }

    results.forEach(article => {
        const item = document.createElement('div');
        item.className = 'helpblogs-search-item';

        const img = document.createElement('img');
        img.src = window.ASSETS.videoSupportIcon;
        img.alt = '';

        const title = document.createElement('span');
        title.textContent = article.title;

        item.append(img, title);

        item.addEventListener('click', () => {
            window.location.href = article.onlineStoreUrl;
        });

        container.appendChild(item);
    });

    container.classList.add('show');
}

function hideHelpSearchResults() {
    document.getElementById('helpblogs-search-results-pc')?.classList.remove('show');
    document.getElementById('helpblogs-search-results-mobile')?.classList.remove('show');
}

// 初始化 HelpBlogs 搜索
function initHelpBlogsSearch() {
    // 等待 DOM 渲染完成（因为 fetchAndRenderBlog 是异步的）
    const checkInterval = setInterval(() => {
        const pcInput = document.querySelector('#supportCenter_helpblogs .topHeader .search input');
        const mobileInput = document.querySelector('#supportCenter_helpblogs_mobile .topHeader .search input');

        if (pcInput || mobileInput) {
            clearInterval(checkInterval);

            // 绑定 PC 输入
            if (pcInput) {
                pcInput.id = 'helpblogs-search-input-pc'; // 赋予 ID 方便定位
                pcInput.addEventListener('input', (e) => handleHelpSearch(e, 'pc'));
            }

            // 绑定 Mobile 输入
            if (mobileInput) {
                mobileInput.id = 'helpblogs-search-input-mobile';
                mobileInput.addEventListener('input', (e) => handleHelpSearch(e, 'mobile'));
            }
        }
    }, 100);
}

function handleHelpSearch(event, device) {
    const keyword = event.target.value.trim();
    clearTimeout(helpSearchTimer);

    if (keyword.length < HELP_MIN_LENGTH) {
        hideHelpSearchResults();
        return;
    }

    helpSearchTimer = setTimeout(async () => {
        try {
            const res = await debugFetchArticlesByTagsAndNameCode(keyword, 50);
            const container = device === 'pc'
                ? document.getElementById('helpblogs-search-results-pc')
                : document.getElementById('helpblogs-search-results-mobile');

            // 定位：放在输入框正下方
            if (container && event.target.getBoundingClientRect) {
                const rect = event.target.getBoundingClientRect();
                container.style.left = `${rect.left + window.scrollX}px`;
                container.style.top = `${rect.bottom + window.scrollY}px`;
                container.style.width = `${rect.width}px`;
            }

            renderHelpSearchResults(res, container);
        } catch (err) {
            console.error('HelpBlogs search error:', err);
            hideHelpSearchResults();
        }
    }, HELP_DEBOUNCE);
}

// 全局点击隐藏
document.addEventListener('click', (e) => {
    const isInsidePC = e.target.closest('#helpblogs-search-input-pc, #helpblogs-search-results-pc');
    const isInsideMobile = e.target.closest('#helpblogs-search-input-mobile, #helpblogs-search-results-mobile');

    if (!isInsidePC && !isInsideMobile) {
        hideHelpSearchResults();
    }
});

// 启动
// function addListeningFunctionSearch() {
    if (typeof debugFetchArticlesByTagsAndNameCode === 'function') {
        document.addEventListener('DOMContentLoaded', () => {
            // 等主内容加载后再初始化
            setTimeout(initHelpBlogsSearch, 500);
        });
    }
// }